import Content from "@/components/Content";
import EmailFormInput from "@/components/Authentication/EmailFormInput";
import FormHeader from "@/components/Authentication/FormHeader";
import Modal from "@/components/Modal";
import { WithUserLayout } from "@/components/UserLayout";
import validateEmail from "@/functions/ValidateEmail";
import { Page } from "@/types/Page";
import Link from "next/link";
import { ChangeEvent, FormEvent, useState } from "react";
import { useForgotPassword } from "@/services/AuthenticationService";
import AuthenticationBackground from "@/components/Authentication/AuthenticationBackground";


interface ForgotPasswordFormInputElement {
    email: HTMLInputElement
}

const ForgotPasswordPage: Page = () => {
    const [email, setEmail] = useState("");
    const [emailInputValidation, setEmailInputValidation] = useState("");
    const [open, setOpen] = useState(false);

    const { forgotPassword } = useForgotPassword();

    const isForgotPasswordFormValid = (email: string) => {
        setEmailInputValidation('');

        const emailValidationResult = validateEmail(email)
        if (!emailValidationResult.isValid)
            setEmailInputValidation(emailValidationResult.validationMessage);
        return emailValidationResult.isValid;
    }

    const handleChangeEmail = (event: ChangeEvent<HTMLInputElement>) => {
        event.preventDefault();
        setEmail(event.currentTarget.value);
    }

    const handleSubmitEmail = async (event: FormEvent<HTMLFormElement> &  { currentTarget : {elements: ForgotPasswordFormInputElement}}) => {
        event.preventDefault();
        if (!isForgotPasswordFormValid(email)) return;
        setOpen(true)
        await forgotPassword(email);
    }
    
    return (
        <AuthenticationBackground>
            <Content>
                <div className="flex justify-center items-center min-h-screen m-2">
                    <div className="bg-white p-12 rounded-xl mx-auto my-20 lg:mx-20">
                        {/* Form */}
                        <form onSubmit={handleSubmitEmail} noValidate>

                            {/* Header */}
                            <FormHeader
                                headerText="Forgot Password"
                                subHeaderText="Please provide your email address, and we&apos;ll send you a new password. Kindly refrain from sharing your
                                    password publicly."
                            ></FormHeader>
                            
                            {/* Email Input */}
                            <EmailFormInput 
                                id="email"
                                validationMessage={emailInputValidation}
                                autoFocus={true}
                                value={email}
                                onChange={handleChangeEmail}
                            />

                            {/* Reset Password Button */}
                            <button
                                type="submit"
                                className="text-center w-full py-2 text-white bg-[#93885B] rounded-xl shadow"
                            >
                                Reset Password
                            </button>

                            {/* Sign Up Link */}
                            <p className="text-center text-black p-4 mt-4">
                                Remember password?{' '}
                                <Link href="/login" className="text-[#93885B] hover:underline hover:text-[#0a58ca]">
                                    Login
                                </Link>
                            </p>
                        </form>
                    </div>
                </div>

                <Modal 
                    open={open}
                    onClose={() => setOpen(false)}
                    modalTitle="Your reset password request has been accepted"
                    imageUri="success-apply.svg"
                >
                    <p className="mt-4 font-medium text-slate-500 text-base text-center max-w-sm">
                        Please check your email for the new password we&apos;ve sent you. Please refrain from sharing your
                        password publicly.
                    </p>
                </Modal>
            </Content>
        </AuthenticationBackground>

    );
}

ForgotPasswordPage.layout = WithUserLayout;
export default ForgotPasswordPage;
